import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseProgressBarConfig, BaseProgressBarDefaultConfig, } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const textColors = [
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
    Color.MEDIUM_GREY,
];
const types = ["classic", "slanted"];
export const BasicProgressBar = defineOverlay({
    defaults: {
        ...BaseProgressBarDefaultConfig,
        textColor: Color.MEDIUM_GREY,
        type: "classic",
    },
    details: {
        category: "progress",
        description: "Utilize our dynamic Basic Progress Bar overlay to enhance your Tiltify fundraising campaign. Track your progress, recognize donors and promote upcoming milestones and incentives.",
        features: [
            "Fits well into any streaming layouts",
            "Fundraising amount",
            "Goal",
            "Donors, milestones and rewards displayed in scroller",
            "Milestones display every 10 minutes",
            "Slanted and Classic themes",
        ],
        flags: {
            isFeatured: true,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "progress-bars/basic.png",
        name: "Basic Progress Bar",
        obsDimensions: {
            height: "110px",
            width: "1120px",
        },
        path: "/overlays/basic/",
        shortName: "Basic",
        slug: "basic",
    },
    schema: BaseProgressBarConfig.extend({
        textColor: z
            .enum(textColors)
            .default(() => BasicProgressBar._config.defaults.textColor)
            .optional(),
        type: z
            .enum(types)
            .default(() => BasicProgressBar._config.defaults.type)
            .optional(),
    }),
});
//# sourceMappingURL=basic.js.map